import { Injectable } from '@angular/core';
import { HeaderFooterMachCore } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { AirportDropDown } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { SearchItem, TabsOptions } from '@com-delta-omnichannel/mach-core-js';
import { CarsLocationItem } from '../../models/interface/booking-cars/booking-cars.interfaces';
import { AemPropertyAccessor } from '../../utils/booking-stays/aem-property-accessor';

@Injectable({ providedIn: 'root' })
export class StaysAirportAdapter {
  getAirPortModalContent(
    aem: HeaderFooterMachCore,
    location?: CarsLocationItem[]
  ): AirportDropDown {
    return {
      airportList: this.getAirportList(aem, location),
      mobileCloseHeaderText: AemPropertyAccessor.getString(
        aem,
        'airportModalContent.mobileCloseHeaderText'
      ),
      floatingLabelText: AemPropertyAccessor.getString(
        aem,
        'airportModalContent.floatingLabelText'
      ),
      tabOptions: this.getTabOptions(aem)
    };
  }

  getItems(location?: CarsLocationItem[]): SearchItem[] {
    return location ? this.transformLocationsToDropdownItems(location) : [];
  }

  private getTabOptions(aem: HeaderFooterMachCore): TabsOptions {
    const searchLabel =
      AemPropertyAccessor.getString(aem, 'searchOptions.placeHolderLabel') ||
      'Search';
    return {
      id: 'tabs-width-fixed-small',
      tabVariant: 'standard',
      tabSize: 'small',
      tabWidth: 'fixed',
      tabItems: [
        { id: 'search', label: searchLabel, value: searchLabel, selected: true }
      ]
    };
  }

  private getAirportList(
    aem: HeaderFooterMachCore,
    location?: CarsLocationItem[]
  ): AirportDropDown['airportList'] {
    return {
      id: 'stays-search-transparent',
      title: AemPropertyAccessor.getString(
        aem,
        'airportModalContent.airportList.title'
      ),
      placeholder: AemPropertyAccessor.getString(
        aem,
        'airportModalContent.airportList.placeholder'
      ),
      hasExternalFiltering: true,
      shouldAutoCapitalize: true,
      menuVariant: 'transparent',
      hasAutocomplete: AemPropertyAccessor.getBoolean(
        aem,
        'airportModalContent.airportList.hasAutocomplete'
      ),
      items: this.getItems(location),
      errorConfig: {
        validateOnInput: false
      }
    };
  }

  private transformLocationsToDropdownItems(
    locations: CarsLocationItem[]
  ): Array<{
    id: string;
    code: string;
    label: string;
    selected: boolean;
    value: string;
  }> {
    return locations.map((loc, index) => ({
      id: String(index + 1),
      code: loc.code,
      label: loc.name,
      selected: false,
      value: loc.code
    }));
  }
}
